module.exports = __webpack_public_path__ + "static/media/hero-image.9db25f98.png";